import axios from "axios";
import { validateOrLogout } from "../services/cognito";
import {
  // ID_TOKEN_COOKIE_KEY,
  ID_TOKEN_KEY,
  // USER_ID_COOKIE_KEY,
  USER_ID_KEY,
} from "../helpers/constant";

axios.interceptors.request.use(async (config) => {
  const token = await validateOrLogout();

  if (token) {
    localStorage.setItem(ID_TOKEN_KEY, token);
    // Cookies.set(ID_TOKEN_COOKIE_KEY, token);
    config.headers.Authorization = `Bearer ${token}`;
  } else {
    localStorage.removeItem(ID_TOKEN_KEY);
    localStorage.removeItem(USER_ID_KEY);
    // Cookies.remove(ID_TOKEN_COOKIE_KEY);
    // Cookies.remove(USER_ID_COOKIE_KEY);
    delete config.headers.Authorization;
  }

  return config;
});
